import React from 'react';
import { Link } from 'react-router-dom';
import { GAME_CONFIG } from '../games';
import styles from '../styles/HomePage.module.css';
import { GOOGLE_INTERSTITIAL_INELIGIBLE_ATTRIBUTES } from '../ads/googleInterstitialAttributes';

// Game Catalog Data - derived from GAME_CONFIG, sorted by order
export const GAME_CATALOG = Object.values(GAME_CONFIG)
  .filter(game => game.level && game.catalogDescription && !game.hidden)
  .sort((a, b) => a.order - b.order)
  .map(game => ({
    id: game.id,
    level: game.level,
    description: game.catalogDescription
  }));

// Game Catalog Section Component
const GameCatalogSection = ({ 
  excludeGameId = null,
  title = "Il Catalogo dei Giochini",
  subtitle = "Entriamo dentro il catalogo dei Giochini e proviamo a capire meglio quali obiettivi ti aiutano a raggiungere."
}) => {
  // Filter out the excluded game if specified
  const filteredCatalog = excludeGameId 
    ? GAME_CATALOG.filter(item => item.id !== excludeGameId)
    : GAME_CATALOG;

  return (
    <section className={styles.catalogSection}>
      <div className={styles.catalogContent}>
        <h2 className={styles.catalogTitle}>{title}</h2>
        <p className={styles.catalogSubtitle}>
          {subtitle}
        </p>
        <div className={styles.catalogGrid}>
          {filteredCatalog.map((item) => {
            const gameConfig = GAME_CONFIG[item.id];
            if (!gameConfig) return null;
            const GameIcon = gameConfig.icon;
            
            return (
              <Link 
                key={item.id} 
                to={`/${gameConfig.pathName}`}
                className={styles.catalogCard}
                {...GOOGLE_INTERSTITIAL_INELIGIBLE_ATTRIBUTES}
              >
                <div 
                  className={styles.catalogCardIcon}
                  style={{ backgroundColor: gameConfig.backgroundColor }}
                >
                  <GameIcon size={48} />
                </div>
                <div className={styles.catalogCardContent}>
                  <div className={styles.catalogCardHeader}>
                    <h3 className={styles.catalogCardTitle}>{gameConfig.displayName}</h3>
                    <span className={styles.catalogCardLevel}>{item.level}</span>
                  </div>
                  <p className={styles.catalogCardDescription}>{item.description}</p>
                </div>
              </Link>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default GameCatalogSection;
